import React from "react";
import { PageCrumbProps } from "../types/PageCrumb";
import "./PageCrumb.css";

export const PageCrumb = (props: PageCrumbProps) => {
    const { currentPageCrumb, pathCrumbs } = props;
    const separator = <span className="separator">&nbsp;/&nbsp;</span>;

    if (!currentPageCrumb || !pathCrumbs?.length) {
        return <></>;
    }

    return (
        <div
            className="path-crumbs flex flex-column sm:flex-row justify-content-start"
            data-cy="path-crumbs"
        >
            {pathCrumbs.map((subPage, index) => (
                <span key={`${subPage}-${index}`} className="path-crumb crumb">
                    {subPage}
                    {separator}
                </span>
            ))}
            <span className="current-page-crumb crumb">{currentPageCrumb}</span>
        </div>
    );
};
